import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "section-text" }, "Información complementaria PEP", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "pep-text" }, " Incluir la siguiente información, nombre y número de identificación: ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "pep-text" }, [
  /*#__PURE__*/_createElementVNode("ol", null, [
    /*#__PURE__*/_createElementVNode("li", null, " Los cónyuges o compañeros permanentes del PEP "),
    /*#__PURE__*/_createElementVNode("li", null, " Los familiares de las PEP, hasta el segundo grado de consanguinidad, segundo de afinidad y primero civil. "),
    /*#__PURE__*/_createElementVNode("li", null, " Los asociados de un PEP, cuando el PEP sea socio de, o esté asociado a, una persona jurídica y, además, sea propietario directa o indirectamente de una participación superior al 5% de la persona jurídica, o ejerza el control de la persona jurídica, en los términos del artículo 261 del Código de Comercio. ")
  ])
], -1)
const _hoisted_4 = { class: "pep" }
const _hoisted_5 = {
  key: 0,
  style: {"height":"62px"}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { style: {"height":"62px"} }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { style: {"height":"62px"} }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { style: {"height":"62px"} }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { style: {"height":"62px"} }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { style: {"height":"62px"} }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { style: {"height":"62px"} }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"62px"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_2,
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_row, { gutter: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 22 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table, {
                  height: "250",
                  data: _ctx.objetoInfoRepresentantePep.RLPep,
                  span: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, { width: "40%" }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("span", null, [
                          _createElementVNode("b", null, _toDisplayString(scope.$index + 1), 1)
                        ]),
                        (_ctx.HabilitaCamposPep)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      class: "section-text-color",
                      label: "Nombre del representante*",
                      width: "220px;"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input, {
                          type: "text",
                          modelValue: scope.row.NombreRLPEP,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.NombreRLPEP) = $event),
                          disabled: !_ctx.HabilitaCamposPep
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                        (_ctx.HabilitaCamposPep)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _withDirectives(_createElementVNode("div", _hoisted_7, null, 512), [
                                [_vShow, !_ctx.validacionInfoRepresentantePep.RLPep.$each.$response.$errors[scope.$index].NombreRLPEP.length]
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoRepresentantePep.RLPep.$each.$response.$errors[scope.$index].NombreRLPEP, (error) => {
                                return (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: error,
                                  class: "section-error-message",
                                  hidden: !_ctx.HabilitaCamposPep
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(error.$message), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["hidden"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      class: "section-text-color",
                      label: "Nombre de PEP*",
                      width: "220px;"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input, {
                          type: "text",
                          modelValue: scope.row.NombrePEP,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.NombrePEP) = $event),
                          disabled: !_ctx.HabilitaCamposPep
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                        (_ctx.HabilitaCamposPep)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _withDirectives(_createElementVNode("div", _hoisted_9, null, 512), [
                                [_vShow, !_ctx.validacionInfoRepresentantePep.RLPep.$each.$response.$errors[scope.$index].NombrePEP.length]
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoRepresentantePep.RLPep.$each.$response.$errors[scope.$index].NombrePEP, (error) => {
                                return (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: error,
                                  class: "section-error-message",
                                  hidden: !_ctx.HabilitaCamposPep
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(error.$message), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["hidden"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Tipo ID*",
                      width: "140px;"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_select, {
                          modelValue: scope.row.TipoIdPEPRL,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.TipoIdPEPRL) = $event),
                          placeholder: "Seleccionar",
                          disabled: !_ctx.HabilitaCamposPep
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.tipoDeIdentificacion && _ctx.parametricas.tipoDeIdentificacion
                .filter(t => t.valor !== 'NIT' && t.valor !== 'TI'), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.codigo,
                                label: item.valor,
                                value: item.valor
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]),
                        (_ctx.HabilitaCamposPep)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _withDirectives(_createElementVNode("div", _hoisted_11, null, 512), [
                                [_vShow, !_ctx.validacionInfoRepresentantePep.RLPep.$each.$response.$errors[scope.$index].TipoIdPEPRL.length]
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoRepresentantePep.RLPep.$each.$response.$errors[scope.$index].TipoIdPEPRL, (error) => {
                                return (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: error,
                                  class: "section-error-message",
                                  hidden: !_ctx.HabilitaCamposPep
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(error.$message), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["hidden"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "N° ID*",
                      width: "150px;"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input, {
                          type: "text",
                          modelValue: scope.row.NumeroIdentificacionPEPRL,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.NumeroIdentificacionPEPRL) = $event),
                          disabled: !_ctx.HabilitaCamposPep
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                        (_ctx.HabilitaCamposPep)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _withDirectives(_createElementVNode("div", _hoisted_13, null, 512), [
                                [_vShow, !_ctx.validacionInfoRepresentantePep.RLPep.$each.$response.$errors[scope.$index].NumeroIdentificacionPEPRL.length]
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoRepresentantePep.RLPep.$each.$response.$errors[scope.$index].NumeroIdentificacionPEPRL, (error) => {
                                return (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: error,
                                  class: "section-error-message",
                                  hidden: !_ctx.HabilitaCamposPep
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(error.$message), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["hidden"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Tipo de vínculo*",
                      width: "130px;"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input, {
                          type: "text",
                          modelValue: scope.row.TipoVinculoPEPRL,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.TipoVinculoPEPRL) = $event),
                          disabled: !_ctx.HabilitaCamposPep
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                        (_ctx.HabilitaCamposPep)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _withDirectives(_createElementVNode("div", _hoisted_15, null, 512), [
                                [_vShow, !_ctx.validacionInfoRepresentantePep.RLPep.$each.$response.$errors[scope.$index].TipoVinculoPEPRL.length]
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoRepresentantePep.RLPep.$each.$response.$errors[scope.$index].TipoVinculoPEPRL, (error) => {
                                return (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: error,
                                  class: "section-error-message",
                                  hidden: !_ctx.HabilitaCamposPep
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(error.$message), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["hidden"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Tipo de PEP*",
                      width: "130px;"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_select, {
                          modelValue: scope.row.TipoPEPRL,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.TipoPEPRL) = $event),
                          placeholder: "Seleccionar",
                          disabled: !_ctx.HabilitaCamposPep
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.tipoDePep, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.codigo,
                                label: item.valor,
                                value: item.valor
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]),
                        (_ctx.HabilitaCamposPep)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _withDirectives(_createElementVNode("div", _hoisted_17, null, 512), [
                                [_vShow, !_ctx.validacionInfoRepresentantePep.RLPep.$each.$response.$errors[scope.$index].TipoPEPRL.length]
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoRepresentantePep.RLPep.$each.$response.$errors[scope.$index].TipoPEPRL, (error) => {
                                return (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: error,
                                  class: "section-error-message"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(error.$message), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, { width: "50" }, {
                      default: _withCtx((scope) => [
                        (scope.$index > 0)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              circle: "",
                              class: "dinamic-form-button",
                              size: "small",
                              type: "success",
                              icon: "el-icon-minus",
                              onClick: ($event: any) => (_ctx.EliminarFilaRLPEP(scope.$index))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        _hoisted_18
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  circle: "",
                  class: "dinamic-form-button",
                  size: "small",
                  type: "success",
                  icon: "el-icon-plus",
                  onClick: _ctx.AgregarFilaRLPEP,
                  disabled: !_ctx.HabilitaCamposPep
                }, null, 8, ["onClick", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}